import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-nav', 'search', 'Meklēšana');
Labels.set('ui-nav', 'searchOpen', 'Atvērt meklēšanu');
Labels.set('ui-nav', 'searchClose', 'Aizvērt meklēšanu');
